const formSubmittedPageTranslations = {
  title: "استعد للتحول",
  description: "رحلتك نحو اللياقة تبدأ في:",
  cta: "شاهد الفيديوهات",
};

export default formSubmittedPageTranslations;
